export const geocodingApiEndpoints = (builder) => ({
    // Forward geocoding: address/query -> coordinates
    geocode: builder.query({
        query: ({ query }) => ({
            url: 'https://nominatim.openstreetmap.org/search',
            method: 'GET',
            params: {
                format: 'json',
                q: query,
                limit: 1,
            },
            headers: {
                'User-Agent': 'Monoweb/1.0',
            },
        }),
        transformResponse: (response) => {
            if (!Array.isArray(response) || response.length === 0) {
                return null;
            }
            const first = response[0];
            return {
                lat: parseFloat(first.lat),
                lon: parseFloat(first.lon),
            };
        },
    }),
    // Reverse geocoding: coordinates -> address
    reverseGeocode: builder.query({
        query: ({ lat, lon }) => ({
            url: 'https://nominatim.openstreetmap.org/reverse',
            method: 'GET',
            params: {
                format: 'json',
                lat,
                lon,
            },
            headers: {
                'User-Agent': 'Monoweb/1.0',
            },
        }),
        transformResponse: (response) => {
            const data = response;
            if (!data?.display_name) {
                return null;
            }
            return {
                displayName: data.display_name,
            };
        },
    }),
});
